import { render, staticRenderFns } from "./MensagensRecebidas.vue?vue&type=template&id=3dcf2062&scoped=true&lang=pug&"
import script from "./MensagensRecebidas.vue?vue&type=script&lang=js&"
export * from "./MensagensRecebidas.vue?vue&type=script&lang=js&"
import style0 from "./MensagensRecebidas.vue?vue&type=style&index=0&id=3dcf2062&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf2062",
  null
  
)

export default component.exports